// extracted by mini-css-extract-plugin
module.exports = {"text":"clean_text_zwNis"};